var _path, _path2, _path3, _path4, _g, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.002 51C102.002 62.5432 98.1468 73.2469 91.6872 81.8519C88.1448 86.4691 83.8731 90.5617 78.9762 93.7099C71.058 98.9568 61.5769 102 51.3665 102C23.3399 102 0.626953 79.1235 0.626953 51C0.626953 22.7716 23.3399 0 51.2623 0C61.4727 0 70.9538 3.04321 78.872 8.18519C83.7689 11.3333 88.0406 15.4259 91.583 20.0432C98.1468 28.7531 102.002 39.3519 102.002 51Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.77315 17.9449C2.71084 17.9449 3.54434 17.2103 3.54434 16.1609C3.54434 15.2165 2.81503 14.377 1.77315 14.377C0.835456 14.377 0.00195312 15.1115 0.00195312 16.1609C0.00195312 17.2103 0.731268 17.9449 1.77315 17.9449Z",
    fill: "url(#paint0_linear_273_12891)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.87666 97.5933C2.81435 97.5933 3.64786 96.8587 3.64786 95.8093C3.64786 94.76 2.91854 94.0254 1.87666 94.0254C0.938972 94.0254 0.105469 94.76 0.105469 95.8093C0.105469 96.8587 0.938972 97.5933 1.87666 97.5933Z",
    fill: "url(#paint1_linear_273_12891)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9229 15.1041C97.8606 15.1041 98.5899 14.3695 98.5899 13.4251C98.5899 12.4807 97.8606 11.7461 96.9229 11.7461C95.9852 11.7461 95.2559 12.4807 95.2559 13.4251C95.2559 14.3695 95.9852 15.1041 96.9229 15.1041Z",
    fill: "url(#paint2_linear_273_12891)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_273_12891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9173 24.9032C44.2645 25.2029 42.7619 25.6524 41.2594 26.2518C32.2446 29.8483 25.934 37.9405 24.4315 47.2316C23.8305 50.5284 23.9809 53.8252 24.5819 57.2718C27.5868 71.9577 42.1608 81.5486 56.885 78.4016C71.6092 75.2547 81.2252 60.8685 78.07 46.1827C77.0182 40.9377 74.464 36.1424 70.5576 32.396C64.3975 25.8024 54.9321 22.9551 45.9173 24.9032Z",
    fill: "url(#paint3_linear_273_12891)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.3589 42.5537C62.8452 42.5537 63.25 42.9575 63.25 43.4712V43.9462C63.25 44.4474 62.8452 44.8637 62.3589 44.8637H41.6423C41.1548 44.8637 40.75 44.4474 40.75 43.9462V43.4712C40.75 42.9575 41.1548 42.5537 41.6423 42.5537H45.287C46.0273 42.5537 46.6716 42.0275 46.8382 41.285L47.029 40.4325C47.3257 39.2712 48.3019 38.5 49.4191 38.5H54.5809C55.686 38.5 56.6731 39.2712 56.9588 40.3712L57.163 41.2837C57.3284 42.0275 57.9727 42.5537 58.7143 42.5537H62.3589ZM60.5073 59.9175C60.8878 56.3713 61.554 47.9464 61.554 47.8614C61.5783 47.6039 61.4944 47.3602 61.3279 47.1639C61.1492 46.9802 60.923 46.8714 60.6738 46.8714H43.3357C43.0852 46.8714 42.8469 46.9802 42.6816 47.1639C42.5138 47.3602 42.4312 47.6039 42.4433 47.8614C42.4456 47.877 42.4695 48.1738 42.5094 48.6699C42.687 50.874 43.1815 57.0127 43.501 59.9175C43.7271 62.0575 45.1312 63.4025 47.1651 63.4513C48.7345 63.4875 50.3514 63.5 52.0047 63.5C53.562 63.5 55.1437 63.4875 56.7617 63.4513C58.8661 63.415 60.269 62.0938 60.5073 59.9175Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_273_12891",
    x: 14.2088,
    y: 20.6108,
    width: 74.3012,
    height: 74.3793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6.15002
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.92002
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.1125 0 0 0 0 0.295916 0 0 0 0 1 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_273_12891"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_273_12891",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_273_12891",
    x1: 0.00195312,
    y1: 16.2429,
    x2: 3.36993,
    y2: 16.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_273_12891",
    x1: 0.177775,
    y1: 95.8704,
    x2: 3.54575,
    y2: 95.8704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_273_12891",
    x1: 95.2965,
    y1: 13.4426,
    x2: 98.4596,
    y2: 13.4426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_273_12891",
    x1: 34.1744,
    y1: 29.9782,
    x2: 72.4647,
    y2: 71.2912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B5FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079BA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteImage);
export default __webpack_public_path__ + "static/media/deleteImage.dd976278f42928ad7c58f55cdeaf051f.svg";
export { ForwardRef as ReactComponent };